export default "__VITE_ASSET__CkKK0q$G__"